module.exports = __webpack_public_path__ + "img/edu_solution_sheet_bg.60f02854.png";